import { gql } from '@apollo/client';

export const USER_SIGNIN_MUTATION = gql`
  mutation userSignin($input: user_signinInput!) {
    userSignin(input: $input) {
      token
      user {
        ... on Professional {
          accountStatus
          code
          contactDetail {
            addressPlace
            addressStreet
            addressCountry
            addressPostalCode
            __typename
          }
          createdAt
          creatorId
          email
          familyName
          firstName
          id
          lastOtpAt
          otpSecret
          twoFactorEnabled
          type
          updatedAt
          user {
            id
            isActive
            language
            timezone
            __typename
          }
          __typename
        }
        ... on Client {
          accountStatus
          actionPlanStatus {
            id
            name
            color
            sorting
            __typename
          }
          allergies {
            id
            allergy {
              id
              name
            }
          }
          allergyMisc {
            id
            other
            clientId
            createdAt
            updatedAt
            __typename
          }
          bio {
            id
            sex
            length
            weight
            clientId
            createdAt
            updatedAt
            __typename
            dateOfBirth
            isVegetarian
            clientBioFemale {
              id
              createdAt
              updatedAt
              __typename
              clientBioId
              firstMensAge
              isInMenopause
            }
            waistCircumference
          }
          bloodlineDiseases {
            id
            disease
            clientId
            createdAt
            updatedAt
            __typename
            familyMembers
          }
          careerAndEducationDetail {
            id
            clientId
            createdAt
            updatedAt
            profession
            __typename
            educationLevel
          }
          caregiverContactDetails {
            id
            name
            clientId
            createdAt
            isPrimary
            updatedAt
            __typename
            addressPlace
            relationship
            addressNumber
            addressStreet
            addressCountry
            telephoneNumber
            addressPostalCode
            telephoneCountryCode
          }
          clientGid
          colleagueNotes {
            id
            title
            client {
              id
              email
            }
          }
          createdAt
          email
          familyDetail {
            id
            type
            clientId
            createdAt
            updatedAt
            fatherName
            motherName
            __typename
            maritalStatus
            numberOfSisters
            numberOfBrothers
            numberOfMaleChildren
            parentsMaritalStatus
            numberOfFemaleChildren
          }
          familyName
          firstName
          foodIntoleranceMisc {
            id
            other
            clientId
            createdAt
            updatedAt
            __typename
          }
          foodIntolerances {
            id
            foodIntolerance {
              id
              name
            }
          }
          gid
          hairAndMineralAnalyses {
            id
            iron
            lead
            zinc
            boron
            cobalt
            copper
            nickel
            adminId
            arsenic
            cadmium
            calcium
            lithium
            mercury
            aluminum
            chromium
            clientId
            hairType
            selenium
            createdAt
            magnesium
            manganese
            potassium
            updatedAt
            molybdenum
            phosphorus
            isSeenByPro
            reportNumber
            attachmentUrl
            clientViewable
            dateOfAnalysis
            professionalViewable
          }
          heartRateVariabilities {
            id
            data
            adminId
            clientId
            createdAt
            updatedAt
            __typename
            isSeenByPro
            reportNumber
            attachmentUrl
            clientViewable
            dateOfAnalysis
            durationOfAnalysis
            specialistReportUrl
            professionalViewable
          }
          id
          importantNotesToProfessional {
            id
            note
            clientId
            createdAt
            updatedAt
            __typename
            yearOfEvent
          }
          involvedHealthProfessionals {
            id
            name
            address
            forWhat
            clientId
            createdAt
            sinceWhen
            updatedAt
            __typename
            telephoneNumber
            telephoneCountryCode
          }
          iodineTests {
            id
            testData {
              id
              adminId
              createdAt
              updatedAt
              __typename
              iodineTestId
              iodideSpotValue
              iodide24hExcretion
              bromideSpotValue
              bromide24hExcretion
              chlorideSpotValue
              chloride24hExcretion
              fluorideSpotValue
              fluoride24hExcretion
              dateOfAnalysis
              reportNumber
            }
            createdAt
            updatedAt
            __typename
            clientViewable
          }
          irCombis {
            id
            crpHs
            glucose
            cPeptide
            clientId
            insuline
            createdAt
            updatedAt
            isDiabetic
            __typename
            isSeenByPro
            homocysteine
            reportNumber
            homa2CInsulin
            homa2CPeptide
            clientViewable
            dateOfAnalysis
            ldlOxAntistoffen
            homa2CInsulinPctB
            homa2CInsulinPctS
            homa2CPeptidePctB
            homa2CPeptidePctS
            professionalViewable
            isSyntheticInsulinUse
          }
          otherHealthProfessionals {
            id
            name
            address
            forWhat
            clientId
            createdAt
            sinceWhen
            updatedAt
            __typename
            telephoneNumber
            telephoneCountryCode
          }
          otherMedication {
            id
            content
            clientId
            __typename
          }
          personalContactDetail {
            id
            clientId
            createdAt
            updatedAt
            __typename
            addressPlace
            addressNumber
            addressStreet
            addressCountry
            telephoneNumber
            addressPostalCode
            telephoneCountryCode
          }
          prescribedMedications {
            id
            content
            clientId
            createdAt
            updatedAt
            __typename
          }
          professionalCode
          professionalDocumentUploads {
            id
            title
            client {
              id
              email
            }
            createdAt
            updatedAt
            __typename
            documentUrl
            clientViewable
          }
          professionalHealthComplaintNote {
            id
            tags
            content
            clientId
            createdAt
            updatedAt
            __typename
            attachmentUrls
          }
          professionalLogs {
            id
            title
            client {
              id
              email
            }
            content
            createdAt
            updatedAt
            __typename
            attachmentUrls
            energyLevelVasScore
            clientSummaryAndActions
            generalWellBeingVasScore
            mainHealthProblemVasScore
          }
          questionnaireAssignments {
            client {
              firstName
              familyName
            }
            clientId
            id
            questionnaire {
              closingRemarks
              content
              deactivatedOn
              description
              group
              id
              title
              userId
            }
            questionnaireId
            response {
              id
              type
              answers
              createdAt
              updatedAt
              isSeenByPro
            }
            updatedAt
          }
          requestForHelp {
            id
            clientId
            createdAt
            updatedAt
            __typename
            description
          }
          specialists {
            id
            name
            address
            forWhat
            sinceWhen
            clientId
            createdAt
            updatedAt
            __typename
            telephoneNumber
            telephoneCountryCode
          }
          surgeries {
            id
            when
            forWhat
            clientId
            createdAt
            updatedAt
            __typename
          }
          timelineEvents {
            id
            day
            year
            month
            client {
              id
              email
            }
            content
            createdAt
            updatedAt
            __typename
          }
          timelineTabs {
            id
            name
            color
            client {
              id
              email
            }
            createdAt
            updatedAt
            __typename
          }
          updatedAt
          user {
            id
            isActive
            language
            timezone
            __typename
          }
          vaccinations {
            id
            when
            clientId
            createdAt
            otherName
            updatedAt
            __typename
            vaccination {
              id
              name
            }
            physiologicalResponse
          }
          __typename
        }
      }
    }
  }
`;